import Vue from 'vue'
import {
	Tool
} from "./Tool.js";
import {
	getDeviceTypeName
} from './nativeOtherOperate.js'
import {
	Toast
} from 'vant'
Vue.use(Toast)

import JsBridge from "./JsBridge"

var tool = null

function getCurrentTools() {
	if (!tool) {
		tool = Tool.getTools()
	}
	if (!tool) {
		return true
	}
	return false
}

export function testDownDMToSBox(url, fileName) {
	if (getDeviceTypeName() === 'android') {
		window.WebViewJavascriptBridge.callHandler(
			'downWithSkipSecureToSBOX', {
				'url': url,
				'fileName': fileName,
				'inSBox':false,
				'headers': null
			}, false,
			function(responseData) {
				//todo设置metaInfo 调用getAppToken
				console.log('-WebViewJavascriptBridge-downWithDMToSBOX', responseData)
			}
		)
	}
}


export function testActivity() {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			tool.testActivityResult(plus.android.runtimeMainActivity(), '1234567')
			break;
		case 'plusiOS':
			break;
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':
			break;
		default:

			break;
	}
}

//
export function testDownloadFile(url, fileName, appCode, body, result) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			tool.downloadWithDownloadManager(plus.android.runtimeMainActivity(), url, fileName, appCode, body, result)
			break;
		case 'plusiOS':
			break;
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':
			break;
		default:

			break;
	}
}


//
export function testDemo() {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			tool.testDemo()
			break;
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':
			break;
		default:

			break;
	}
}

export function test() {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			break;
		case 'plusiOS':
			break;
		case 'Harmony':
			console.log('Harmony')
			try {
				let result = app.test()
				console.log('typeof tool.test-=', result)
			} catch (e) {
				console.log('app.test', e)
			}
			break;
		case 'Android':
			break;
		case 'iOS':
			break;
		default:
			break;
	}
}

export function testVersion() {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			break;
		case 'plusiOS':
			if (getCurrentTools()) {
				return
			}
			return tool.testVersion()
			break;
		case 'Harmony':

			break;
		case 'Android':
			try {
				console.log('typeof tool.testVersion()-=', typeof tool.testOneParams)
				tool.testOneParams('one')
				tool.testOneParams('one', 'two')
			} catch (err) {
				console.log('testVersion', err)
			} finally {
				console.log('testVersion-complete')
			}
			break;
		case 'iOS':

			break;
		default:

			break;
	}
}

export function testCopyFile(uri) {
	switch (getDeviceTypeName()) {
		case 'plusAndroid':
			if (getCurrentTools()) {
				return
			}
			return tool.copyContentProviderFileToSandBox(plus.android.runtimeMainActivity(), uri)
			break;
		case 'plusiOS':
			break;
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':
			break;
		default:

			break;
	}
}

//
/*export function testDemo() {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':

			break;
		case 'iOS':
			tool.testDemo()
			break;
		default:

			break;
	}
}

export function test() {
	switch (switchDevice()) {
		case 'Harmony':
			console.log('Harmony')
			try {
				let result = app.test()
				console.log('typeof tool.test-=', result)
			} catch (e) {
				console.log('app.test', e)
			}
			break;
		case 'Android':
			break;
		case 'iOS':
			break;
		default:
			break;
	}
}

export function testVersion() {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			try {
				console.log('typeof tool.testVersion()-=', typeof tool.testOneParams)
				tool.testOneParams('one')
				tool.testOneParams('one', 'two')
			} catch (err) {
				console.log('testVersion', err)
			} finally {
				console.log('testVersion-complete')
			}
			break;
		case 'iOS':
			return tool.testVersion()
			break;
		default:

			break;
	}
}

export function testCopyFile(uri) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			return tool.copyContentProviderFileToSandBox(plus.android.runtimeMainActivity(), uri)
			break;
		case 'iOS':
			break;
		default:

			break;
	}
}

export function startDianjuQuickSign(aFileName, infos, positions) {
	if (switchDevice() === 'Android') {
		return tool.startDijuQuickSign(plus.android.runtimeMainActivity(), aFileName, infos, positions)
	}
}

//1竖屏 2横屏
export function harmonyScreenSwitch(flag) {
	if (switchDevice() === 'Harmony') {
		return harmonyEsign.screenSwitch(flag)
	}
}


export function harmonyStartScan() {
	if (switchDevice() === 'Harmony') {
		return harmonyEsign.startScan()
	}
}

export function harmonyTakePhoto() {
	if (switchDevice() === 'Harmony') {
		return harmonyEsign.takePhoto()
	}
}

export function harmonySelectImage() {
	if (switchDevice() === 'Harmony') {
		return harmonyEsign.selectImage()
	}
}

export function isHarmony() {
	return switchDevice() === 'Harmony'
}

export function compressImage(path) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			return tool.compressImage(path)
			break;
		case 'iOS':
			return tool.compressImage(path)
			break;
		default:

			break;
	}
}

//
export function saveFileToDevice(fileUrl, fileName) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			tool.saveFileToDevice(plus.android.runtimeMainActivity(), fileUrl, fileName)
			break;
		case 'iOS':
			tool.saveFileToDevice(fileUrl, fileName)
			break;
		default:

			break;
	}
	// if (Tool.checkIsHarmonyOS()) {
	// 	//metaInfo = app.getMetaInfo()
	// } else {
	// 	if (!window.plus) {
	// 		return
	// 	}
	// 	if (!tool) {
	// 		tool = Tool.getTools()
	// 	}
	// 	if (!tool) {
	// 		//realLiveAuthFaild('调用认证失败，请重试！')
	// 		return
	// 	}
	// 	if (plus.os.name === 'Android') {
	// 	}else if (plus.os.name === 'iOS') {
	// 	}else{
	// 	}
	// }
}

//
export function fromateDownloadPath(fileName) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			break;
		case 'iOS':
			fileName = 'Pandora/' + fileName
			break;
		default:

			break;
	}
	return fileName
}

//
export function saveFileToDownloads(sourceFileName, fileName) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			return tool.saveFileToDownloads(plus.android.runtimeMainActivity(), sourceFileName, fileName)
			break;
		case 'iOS':
			return tool.saveFileToDownloads(sourceFileName, fileName)
			break;
		default:

			break;
	}
}

//
export function saveCorpQrCode(corpId, codeurl) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			tool.saveCorpQrCode(plus.android.runtimeMainActivity(), corpId, codeurl)
			break;
		case 'iOS':
			tool.saveCorpQrCode(corpId, codeurl)
			break;
		default:

			break;
	}
}

//
export function openFile(path, type) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			tool.openFile(plus.android.runtimeMainActivity(), path, type)
			break;
		case 'iOS':
			break;
		default:

			break;
	}
}

//
export function openCorpQrCode(corpId, codeurl) {
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			tool.openCorpQrCode(plus.android.runtimeMainActivity(), corpId)
			break;
		case 'iOS':
			//if (tool.initVerify()) {
			tool.openCorpQrCode(corpId, codeurl)
			//}
			break;
		default:

			break;
	}
}


export function deleteInternalFile(apkPath) {
	if (switchDevice() === 'Android') {
		return tool.deleteInternalFile(plus.android.runtimeMainActivity(), apkPath)
	}
	return 0
}

export function updateAndroidApk(apkPath) {
	if (switchDevice() === 'Android') {
		return tool.updateAndroidApk(plus.android.runtimeMainActivity(), apkPath)
	}
	return 0
}

//
export function getAppVersion() {
	let version = '1.0'
	switch (switchDevice()) {
		case 'Harmony':

			break;
		case 'Android':
			version = tool.getAppVersionName(plus.android.runtimeMainActivity())
			break;
		case 'iOS':
			version = tool.getAppVersionCode()
			break;
	}
	return version
}


//   INSERT INTO csp.app_version ("id","version","url","app_name","device_type") VALUES
// 	 (1,'1.0','https://xxx.com/xxx.apk','安卓','android');
//   INSERT INTO csp.app_version ("id","version","url","app_name","device_type") VALUES
// 	 (2,'1.0','','鸿蒙','harmonyos');
// 	 INSERT INTO csp.app_version ("id","version","url","app_name","device_type") VALUES
// 	 (3,'1.0','','苹果','ios');
//
export function getDeviceType() {
	let deviceType = ''
	switch (switchDevice()) {
		case 'Harmony':
			deviceType = 'harmony'
			break;
		case 'Android':
			deviceType = 'android'
			break;
		case 'iOS':
			deviceType = 'ios'
			break;
	}
	return deviceType
}


//返回各种类型设备
function switchDevice() {
	if (Tool.checkIsHarmonyOS()) {
		return 'Harmony'
	} else {
		if (!window.plus) {
			return ''
		}
		if (!tool) {
			tool = Tool.getTools()
		}
		console.log('tool', tool)
		if (!tool) {
			return ''
		}
		if (plus.os.name === 'Android') {
			return 'Android'
		} else if (plus.os.name === 'iOS') {
			return 'iOS'
		} else {
			return ''
		}
	}
}*/